<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>
        <div class="mb-4">
          <label class="label-input">Style</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="6">
                <ColorPicker v-model="fields.background" name="background" label="Background" default-color="#ffffff" />
              </v-col>
              <v-col cols="12" md="6">
                <ColorPicker v-model="fields.textColor" name="text-color" label="Text Color" default-color="#000000" />
              </v-col>
              <v-col cols="12" md="4">
                <v-checkbox class="mt-0" v-model="fields.topPadding" label="Top Padding" hide-details />
              </v-col>
              <v-col cols="12" md="4">
                <v-checkbox class="mt-0" v-model="fields.bottomPadding" label="Bottom Padding" hide-details />
              </v-col>
              <v-col cols="12">
                <v-switch v-model="fields.enableContainerPage" label="Enable container page" hide-details />
              </v-col>
              <v-col cols="12" v-if="fields.enableContainerPage">
                <ColorPicker
                  v-model="fields.backgroundContainer"
                  name="background-container"
                  label="Container Background"
                  default-color="#ffffff"
                />
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Card Wrapper</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field v-model.number="fields.maxWidth" type="number" label="Max Width (px)" />
              </v-col>
              <v-col cols="12" md="4">
                <v-checkbox class="mt-0" v-model="fields.enableBorder" label="Enable Border" hide-details />
              </v-col>
              <v-col cols="12" md="4">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="border-color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.borderColor"
                    @change="fields.borderColor = $event.target.value"
                  />
                  <v-text-field v-model="fields.borderColor" label="Border Color" />
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Title Card</label>
          <div class="group-item">
            <v-checkbox v-model="fields.showTitle" label="Show title" hide-details class="mt-0 mb-2" />
            <ckeditor :editor="editor" v-model="fields.titleCard" :config="editorConfig" />
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input mb-1">Images Before and After</label>
          <v-row class="mt-0">
            <v-col cols="6">
              <div class="group-item">
                <div class="text-center font-weight-bold mb-2">Before</div>
                <v-text-field v-model="fields.imageBefore.text" label="Text" />
                <div class="d-flex align-center gap-3 mb-2">
                  <input
                    type="color"
                    name="before-text-color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.imageBefore.colorDecor"
                    @change="fields.imageBefore.colorDecor = $event.target.value"
                  />
                  <v-text-field v-model="fields.imageBefore.colorDecor" label="Text Color" />
                </div>
                <div class="d-flex align-center gap-3 mb-2">
                  <input
                    type="color"
                    name="before-bg-color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.imageBefore.bgDecor"
                    @change="fields.imageBefore.bgDecor = $event.target.value"
                  />
                  <v-text-field v-model="fields.imageBefore.bgDecor" label="Background Color" />
                </div>
                <label>Image Before</label>
                <UploadImage
                  @callback="obj => handleUploadImage(obj, 'before')"
                  :image="{ imageSrc: fields.imageBefore.img }"
                  :height="`250`"
                  :typeUpload="'image'"
                  @callbackDelete="handleRemoveUploadBefore"
                />
              </div>
            </v-col>
            <v-col cols="6">
              <div class="group-item">
                <div class="text-center font-weight-bold mb-2">After</div>
                <v-text-field v-model="fields.imageAfter.text" label="Text" />
                <div class="d-flex align-center gap-3 mb-2">
                  <input
                    type="color"
                    name="after-text-color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.imageAfter.colorDecor"
                    @change="fields.imageAfter.colorDecor = $event.target.value"
                  />
                  <v-text-field v-model="fields.imageAfter.colorDecor" label="Text Color" />
                </div>
                <div class="d-flex align-center gap-3 mb-2">
                  <input
                    type="color"
                    name="after-bg-color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.imageAfter.bgDecor"
                    @change="fields.imageAfter.bgDecor = $event.target.value"
                  />
                  <v-text-field v-model="fields.imageAfter.bgDecor" label="Background Color" />
                </div>
                <label>Image After</label>
                <UploadImage
                  @callback="obj => handleUploadImage(obj, 'after')"
                  :image="{ imageSrc: fields.imageAfter.img }"
                  :height="`250`"
                  :typeUpload="'image'"
                  @callbackDelete="handleRemoveUploadAfter"
                />
              </div>
            </v-col>
          </v-row>
        </div>

        <div class="">
          <label class="label-input">Explication</label>
          <div class="group-item">
            <v-checkbox v-model="fields.showExplication" label="Show explication" hide-details class="mt-0 mb-2" />
            <ckeditor :editor="editor" v-model="fields.explication" :config="editorConfig" />
          </div>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import ColorPicker from './common/color-picker.vue';
export default {
  name: 'card-compare-yuri-section-editor',
  components: {
    UploadImage,
    ColorPicker,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Card Compare Yuri Section',
        enableAnchor: false,
        topPadding: true,
        bottomPadding: true,
        background: '#FFFFFF',
        textColor: '#000000',
        enableContainerPage: false,
        backgroundContainer: '#FFFFFF',
        showTitle: true,
        titleCard: '',
        maxWidth: 700,
        enableBorder: true,
        borderColor: '#e5e7eb',
        imageBefore: {
          img: '',
          text: 'Before',
          bgDecor: '#17d4f4',
          colorDecor: '#ffffff',
        },
        imageAfter: {
          img: '',
          text: 'After',
          bgDecor: '#17d4f4',
          colorDecor: '#ffffff',
        },
        explication: '',
        showExplication: true,
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
      imageBefore: {
        ...this.fields.imageBefore,
        ...(this.sectionEditor.sectionExtract?.imageBefore || {}),
      },
      imageAfter: {
        ...this.fields.imageAfter,
        ...(this.sectionEditor.sectionExtract?.imageAfter || {}),
      },
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleUploadImage(obj, type) {
      if (type === 'before') {
        this.fields.imageBefore.img = obj.imageSrc;
      } else {
        this.fields.imageAfter.img = obj.imageSrc;
      }
    },
    handleRemoveUploadBefore() {
      this.fields.imageBefore.img = '';
    },
    handleRemoveUploadAfter() {
      this.fields.imageAfter.img = '';
    },
    handleSave() {
      const payload = {
        ...this.fields,
        maxWidth: Number(this.fields.maxWidth) > 0 ? Number(this.fields.maxWidth) : 700,
      };
      const updateHtml = updateHtmlFromData.sectionCardCompareYuri(this.sectionEditor.section.html, payload);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.group-item {
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  padding: 12px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
